<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" id="droparea" style="position:relative;height:100%;">  
    <LightBox id="customlightboxtmp" ref="lightbox"
              :media="media"
              :show-caption="true"
              :show-light-box="false" />

  </div>
</template>

<script>
  var media = [
    {
      thumb: '',
      src: '',
      caption: ''
    }
  ]
  import LightBox from 'vue-image-lightbox'

  export default {
    name: "custom-lightbox",
    display: "Nested (v-model & vuex)",
    order: 16,
    components: {      
      LightBox,
    },
    data() {
      return {
        media,
      };
    },
    computed: {
     
    },
    props: {
      
    },
    methods: {

      openUrl(url, name) {
        var mimetype = this.getMimeType(url);
        this.$refs.lightbox.showThumbs = false;
        this.$refs.lightbox.showFooterCount = false;

        var mediaObjects = [];
        if (mimetype.indexOf('image') != -1) {
          var obj = {
            thumb: url,
            src: url,
            caption: name,
          }
          mediaObjects.push(obj);
          this.media = mediaObjects;
          this.$refs.lightbox.showImage(0);
          

        } else if (mimetype.indexOf('video') != -1) {
          var obj = {
            thumb: url,
            sources: [
              {
                src: url,
                type: mimetype,
              },
            ],
            type: 'video',
            caption: name,
            width: 800,
            height: 600,
            autoplay: true,
          }
          mediaObjects.push(obj);
          this.media = mediaObjects;
          this.$refs.lightbox.showImage(0);
          lightboxToFront('#customlightboxtmp')
        }
        else {
          if (url.match(/api\/upload\/file/i)) {
            var u = window.location.href;
            var baseUrl = u.split(window.location.pathname)[0];
            url = baseUrl + url; // relative path
          }
          //else if (!url.match(/^http?:\/\//i)) {
          //  url = 'https://' + url;
          //}
          window.open(url, '_blank');
        }
      },

    

      getMimeType(url) {
        var mimetype = '', hash;
        var hashes = url.slice(url.indexOf('?') + 1).split('&');
        if (url.indexOf('mimetype' > -1)) {
          for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            if ("mimetype" == hash[0]) {
              mimetype = hash[1];
            }
          }
        }
        return mimetype;
      },

     
     
      handleRefresh(val) {

        lightboxToOrigin('#customlightboxtmp');
        this.$refs.lightbox.closeLightBox();
      },    
    },
    created() {
      
    },
  };
</script>

<style scoped>
  

</style>



// WEBPACK FOOTER //
// src/components/lightbox/custom-lightbox.vue